import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { CountDownLabels, CountDownUtils } from './countdown.utils';

/*
  <app-countdown
        (onEnd)="<function>()"
        [startDate]="<string>"
        [labels?]="{
            d: 'days',
            h: 'hours',
            m: 'mins',
            s: 'secs'
        }"
        [title?]="<string>">
    </app-countdown>
*/

@Component({
  selector: 'amg-countdown',
  templateUrl: './countdown.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CountdownComponent implements OnInit, OnChanges, AfterViewInit, OnDestroy {
  /**
   * Countdown date
   */
  @Input() date: string | Date;
  /**
   * Countdown labels
   */
  @Input() labels: CountDownLabels;
  /**
   * Countdown title
   */
  @Input() title: string;

  /**
   * Emitter in the end of the countdown
   */
  @Output() onEnd: EventEmitter<boolean>;


  @ViewChild('countDownRef', {static: false}) countdownElRef: ElementRef;

  private _defaultLabels: CountDownLabels = {
    d: 'days',
    h: 'hours',
    m: 'mins',
    s: 'secs',
  };

  private countdownEvent: number;

  constructor(
      private cd: ChangeDetectorRef,
  ) {

    this.onEnd = new EventEmitter();
  }

  /* get isInFuture(): boolean {
     return new Date(this.date) > new Date();
   }*/

  ngOnInit(): void {

    this.labels = this.labels || this._defaultLabels;
  }

  ngAfterViewInit(): void {

    this.countdown();
  }

  ngOnChanges(): void {

    this.ngOnDestroy();
    this.countdown();
  }


  private countdown(): void {
    if (this.countdownElRef?.nativeElement) {
      const $countdownEl = this.countdownElRef.nativeElement;
      this.countdownEvent = CountDownUtils.generateCountDown($countdownEl, this.date, this.labels, this.onCountDownEnd);
    }
  }


  private onCountDownEnd = (): void => {
    this.onEnd.emit(true);
    this.cd.detectChanges();
  };

  ngOnDestroy(): void {
    if (this.countdownEvent) {

      clearInterval(this.countdownEvent);
    }
  }
}
